export const COACH_STORAGE_SUFFIX = {
  recentTeams: 'recentTeams',
  recentRowers: 'recentRowers',
  activeTeamId: 'activeTeamId',
  recentSessions: 'recentSessions',
  selectedSessionId: 'selectedSessionId',
  uploadBatch: 'uploadBatch',
  teamDashboardContext: 'teamDashboardContext',
} as const;

export type CoachStorageSuffix = (typeof COACH_STORAGE_SUFFIX)[keyof typeof COACH_STORAGE_SUFFIX];

export function coachStorageKey(userId: string, suffix: CoachStorageSuffix | string): string {
  return `coach:${userId}:${suffix}`;
}

function clearCoachPrefix(storage: Storage) {
  const toRemove: string[] = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key && key.startsWith('coach:')) toRemove.push(key);
  }
  toRemove.forEach((key) => storage.removeItem(key));
}

/** Removes every key starting with `coach:` from localStorage and sessionStorage. */
export function clearAllCoachStorage(): void {
  if (typeof window === 'undefined') return;
  try {
    clearCoachPrefix(window.localStorage);
  } catch {
    /* non-fatal */
  }
  try {
    clearCoachPrefix(window.sessionStorage);
  } catch {
    /* non-fatal */
  }
}
